import { EXCEPTION_ROOT } from "constants/routes";
import { isEqual } from "lodash";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ENTITY_LINK_RESOLUTION,
  switchWorkspaceForEntityLink,
} from "slices/app/actions/app";
import { selectIsLoggedIn, selectUserWorkspaceId } from "slices/app/selectors";
import { resolveEntityLink } from "utils/entityLinks";

const useEntityWorkspaceResolution = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const isLoggedIn = useSelector(selectIsLoggedIn);
  const workspaceId = useSelector(selectUserWorkspaceId);

  const targetHash = `#${location.pathname}${location.search}`;
  const entityLink = resolveEntityLink(targetHash);
  const resolvedEntityRef = useRef(null);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (isEqual(entityLink, resolvedEntityRef.current)) {
      return;
    }
    resolvedEntityRef.current = entityLink;

    if (!entityLink) {
      return;
    }

    dispatch(switchWorkspaceForEntityLink(targetHash, workspaceId)).then(
      (resolution) => {
        const isStillOnLink = isEqual(resolvedEntityRef.current, entityLink);
        if (!isStillOnLink) {
          return;
        }
        if (resolution === ENTITY_LINK_RESOLUTION.FORBIDDEN) {
          navigate(`${EXCEPTION_ROOT}/access-denied`, { replace: true });
        } else if (resolution === ENTITY_LINK_RESOLUTION.NOT_FOUND) {
          navigate(`${EXCEPTION_ROOT}/not-found`, { replace: true });
        }
      }
    );
  }, [targetHash, isLoggedIn, workspaceId, entityLink, navigate, dispatch]);
};

export default useEntityWorkspaceResolution;
